import { useTranslation } from 'react-i18next';
import { StaffPositionRow } from './StaffPositionRow';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';

export const StaffDepartmentBlock = ({ department }) => {
  const { t } = useTranslation('translations');

  return (
    <Accordion
      defaultExpanded
      sx={{
        '&.MuiAccordion-root.Mui-expanded': {
          m: 0,
        },
        ...(department.isBanner && {
          position: 'sticky',
          top: '64px', // Adjust this value based on your header height
          zIndex: 1000,
          backgroundColor: 'background.paper',
          '& .MuiAccordionSummary-root': {
            position: 'sticky',
            top: '64px', // Same as parent
          },
        }),
      }}
    >
      <AccordionSummary
        sx={{
          bgcolor: department.isBanner ? 'black' : 'primary.main',
          fontSize: department.isBanner ? '18px' : '14px',
          color: 'primary.contrastText',
          '&.MuiAccordionSummary-root.Mui-expanded': {
            minHeight: 48,
            '& .MuiAccordionSummary-content': {
              m: 0,
            },
          },
          '& .editButton': { opacity: 0 },
          '&:hover .editButton': { opacity: 1 },
        }}
      >
        <Box className="w-full flex justify-between">
          <span>{department?.departmentName}</span>
        </Box>
      </AccordionSummary>
      {!department.isBanner && (
        <AccordionDetails sx={{ p: 0 }}>
          <Table
            sx={{
              '& .MuiTableCell-root': {
                border: 1,
                borderColor: 'divider',
                p: 1,
              },
            }}
          >
            <TableHead sx={{ bgcolor: 'divider' }}>
              <TableRow>
                <TableCell align="center" width={50}>
                  №
                </TableCell>
                <TableCell width={300}>{t('PositionName')}</TableCell>
                <TableCell width={150}>{t('Category')}</TableCell>
                <TableCell width={200} align="center">
                  {t('StaffUnits')}
                </TableCell>
                <TableCell>{t('Employee')}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {department.positions?.map((position, index) => (
                <StaffPositionRow key={index} position={position} index={index + 1} />
              ))}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableCell colSpan={3} align="right">
                  {t('Total')}
                </TableCell>
                <TableCell align="center">{department.positions?.length || 0}</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </AccordionDetails>
      )}
    </Accordion>
  );
};
